import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=182c69a2&scoped=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=182c69a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182c69a2",
  null
  
)

export default component.exports